export const NAMED_ACCTS = {
	["0xcd4C346942D5cA794009dA18ba2AA0cCCd221AF8".toLowerCase()]: "jsg funder",
	["0x7A4AA5553120c725F4A0b8235aC4d6753339e533".toLowerCase()]: "jsg buyer",
	["0xb22adA27946C0494077f6FD42e93f5f1Cd6Ae240".toLowerCase()]: "jsg owner",
	["0x04F914c65E72236e93E13CaEacAab390c7FD2972".toLowerCase()]: "jsg torus",
	["0xe81C533237678F59E37BF8F2Cb7027A71994a57e".toLowerCase()]: "ArcShort!",
	["0xf4a62218B89fdA6a0156b7546Fc2650d188FDdAA".toLowerCase()]: "ArcShort",
	["0xEe8BADbe45AC071f43952B9C2d145B116a8E75f4".toLowerCase()]: "ArcLong!",
	["0x2F2abcf3f46891Bc03F209Fd06803D1Ba9995dbf".toLowerCase()]: "ArcLong",
	["0xbb8bB7571a4f6754a424e0A863D1073F6319f548".toLowerCase()]: "Queen1",
	["0x08f1D38a488d21B357F7d207eAC7dE27C65C7a89".toLowerCase()]: "Queen2",
	["0x905B607146A6236F8f1e5C18cB1179985D246525".toLowerCase()]: "Queen3",
	["0xB8B86415c8F407F976A163713b4f2DCAbd5c9b9e".toLowerCase()]: "LeahLong",
	["0xd58fB7591494812F649834bCa54811bd67568444".toLowerCase()]: "LeahLong!",
	["0x8f31f0228CaCE28eb31E0Ba072De57A463Ecb81E".toLowerCase()]: "LeahShort",
	["0xa5Be4534Dd31e82C0955e1fD7300b894DaB48F20".toLowerCase()]: "LeahShort!",
	["0x50f69eD6351164Ec6Aca79A2B1bc574777056730".toLowerCase()]: "PepeShort!",
	["0x0315EfAeB5D076e7f5d42Ac7a399395b29AF8979".toLowerCase()]: "PepeShort",
	["0xc947c5737D7a05a2318bfee7b77B52942c5856C0".toLowerCase()]: "PepeLong!",
	["0xFB4d49f09A0f0Dc1a32941D43D89171Da9BF309D".toLowerCase()]: "PepeLong",
	["0x65b835F4972cEe4d2905f827ED706945900f1E6e".toLowerCase()]: "ThreeFiveSig",
	["0x293e97b593a45c20eD706a26B3F77D36E227407f".toLowerCase()]: "EpochImbalBuyer",
	["0xC31D9C1Bd55fac4489292Ee8A4E68AdFe013c567".toLowerCase()]: "ManuShared",
	["0xf39Fd6e51aad88F6F4ce6aB8827279cffFb92266".toLowerCase()]: "AWSmanuOwner",
	["0x8C5C9BDa2121206724b4541753010525AC85d516".toLowerCase()]: "PW1",
	["0x03D0b9C16f5abfeBa42416F99F4000f12B13444e".toLowerCase()]: "PW2",
	["0xB8B86415c8F407F976A163713b4f2DCAbd5c9b9e".toLowerCase()]: "PW3",
	["0x8f31f0228CaCE28eb31E0Ba072De57A463Ecb81E".toLowerCase()]: "PW4",
	["0x86262f79483ee7Dbc2570EccF5bDd0B19D0FF5C2".toLowerCase()]: "Jesse1",
	["0x878CDd5b17dFbC449a286bb5169f95d5622186bB".toLowerCase()]: "Scribe1",
	["0x2e31684f48de9b7f7bffc10ffeb39b610114e6e3".toLowerCase()]: "Scribe2",
	["0x83DB892a6688B966122Be219fa873BF24D7db79F".toLowerCase()]: "Scribe3",
	["0x266d9ea940c667d97485089981f886963185c63d".toLowerCase()]: "Scribe4",
	["0x400db239e38e4e7d39b149f28d7bae1cf94e59a3".toLowerCase()]: "Scribe5",
	["0x9E72d655515203c30F8890a2bC24740c85D6dCFc".toLowerCase()]: "VaultOpener",
	["0x3Acd29C452f39C61a146B92b483a7BC017108dEb".toLowerCase()]: "Verikono",
	["0xb8CD233fA8233F5BB3879234431dcd939480cB4E".toLowerCase()]: "Bren2",
	["0xbd20D26492D33C09b0D4F29dD8cd1365a1910d57".toLowerCase()]: "Bitget",
	["0x3cBa0AAf43C8E77F1E78eE87759000aEA8c0e0d7".toLowerCase()]: "ReferralTestWallet",
};

export const COUNTRY_BLACK_LIST = [
	"US",
	"CA",
	"IR",
	"KP",
	"CU",
	"SY",
	"MM",
	"RU",
];



export const WHITE_ACCTS = Object.keys(NAMED_ACCTS);
export const API_URL = import.meta.env.VITE_API_URL || `https://api.bracket.fi`;
